import { render, staticRenderFns } from "./Unbind.vue?vue&type=template&id=f5f4e01c&scoped=true&"
import script from "./Unbind.vue?vue&type=script&lang=js&"
export * from "./Unbind.vue?vue&type=script&lang=js&"
import style0 from "./Unbind.vue?vue&type=style&index=0&id=f5f4e01c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4e01c",
  null
  
)

export default component.exports